import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/css/login.css";
import loginImage from "../assets/images/mixkit-left-handed-man-sitting-at-a-table-writing-in-a-notebook-27-original.png";
import LuthLogo from "../assets/images/luth-logo-32x32.png";

import {
  FaHome,
  FaUserEdit,
  FaInfoCircle,
  FaEnvelope,
  FaChevronDown,
} from "react-icons/fa";

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction
  ? "https://schools.luth.gov.ng" || "https://10.0.0.57"
  : "http://localhost:3003";

const Login = () => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(null);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${API_BASE_URL}/api/login`, {
        identifier: identifier.trim(),
        password,
      });

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("matricNo", response.data.matricNo || "");
      localStorage.setItem("userType", response.data.userType || "");
      localStorage.setItem("programme", response.data.programme || "");
      localStorage.setItem("fullName", response.data.fullName || "");
      localStorage.setItem("role", response.data.role || "");
      localStorage.setItem("email", response.data.email || "");
      localStorage.setItem("StudentLevel", response.data.Level || "");
      localStorage.setItem("CalenderYear", response.data.CalenderYear || "");
      localStorage.setItem("entryYear", response.data.entryYear || "");
      localStorage.setItem("entryMode", response.data.entryMode || "");

      navigate("/dashboard");
    } catch (err) {
      setError(
        err.response?.data?.msg || "Invalid credentials. Please try again.",
      );
    }
  };

  return (
    <div className="login-page" >
      <div className="new-students-wrapper">
        <button className="new-students-btn" onClick={() => navigate("/")}>
          View Schools
        </button>
      </div>

      <div className="loginsidebar">
        <button onClick={() => window.open("/")}>
          <FaHome /> <span>Home</span>
        </button>
        <button onClick={() => setShowRegisterPopup(true)}>
          <FaUserEdit /> <span>Registration</span>
        </button>
        <button onClick={() => setShowInfoPopup(true)}>
          <FaInfoCircle /> <span>Information</span>
        </button>
        <button onClick={() => setShowFeedbackPopup(true)}>
          <FaEnvelope /> <span>Feedback</span>
        </button>
      </div>

      <div className="login-container" >
        <div className="login-form-container">
          <form className="form-content" onSubmit={handleLogin}>
            <img src={LuthLogo} alt="" className="LuthLogo" />
            <h3>Lagos University Teaching Hospital School Portal</h3>
            <p className="form-title">Sign In</p>
            {error && <p className="error-message">{error}</p>}

            <label>Matriculation No / Username / Email</label>
            <input
              type="text"
              placeholder="Matric No / Username / Email"
              className="login-input"
              onChange={(e) => setIdentifier(e.target.value)}
              required
            />

            <label>Password</label>
            <input
              type="password"
              placeholder="Password"
              className="login-input"
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit" className="login-button">
              Login
            </button>
          </form>
        </div>

        <div className="illustration-container">
          <img
            src={loginImage}
            alt="Login Illustration"
            className="login-illustration"
          />
        </div>
      </div>

      {showRegisterPopup && (
        <div className="popup">
          <div className="popup-content">
            <h2>Registration Procedure</h2>
            <div className="accordion">
              {[
                {
                  title: "Steps to Register",
                  content:
                    "Visit the portal and create an account using your personal details.",
                },
                {
                  title: "Student Bio-data",
                  content:
                    "Fill in your bio-data, including your full name, date of birth, and contact information.",
                },
                {
                  title: "Payments",
                  content:
                    "Make the required school payments online using the payment portal.",
                },
                {
                  title: "Course Registration",
                  content:
                    "Select and register your courses before the deadline.",
                },
              ].map((item, index) => (
                <div key={index} className="accordion-item">
                  <button
                    className="accordion-title"
                    onClick={() =>
                      setOpenAccordion(openAccordion === index ? null : index)
                    }
                  >
                    {item.title}{" "}
                    <FaChevronDown
                      className={openAccordion === index ? "rotate" : ""}
                    />
                  </button>
                  {openAccordion === index && (
                    <p className="accordion-content">{item.content}</p>
                  )}
                </div>
              ))}
            </div>
            <button onClick={() => setShowRegisterPopup(false)}>Close</button>
          </div>
        </div>
      )}

      {showInfoPopup && (
        <div className="popup">
          <div className="popup-content">
            <h2>Login Information</h2>
            <p>
              Use your <strong>Matric Number</strong>, <strong>Username</strong>
              , or <strong>Email</strong> to log in, then enter your password.
            </p>
            <button onClick={() => setShowInfoPopup(false)}>Close</button>
          </div>
        </div>
      )}

      {showFeedbackPopup && (
        <div className="popup">
          <div className="popup-content">
            <h2>Feedback & Complaints</h2>
            <p>
              All enquiries and complaints should be sent to{" "}
              <strong>schadmin@luthschools.edu.ng</strong>.
            </p>
            <p>
              It is important you state your{" "}
              <strong>
                UTME registration number and Application Number/Matriculation
                Number
              </strong>{" "}
              in your complaints.
            </p>
            <p>Thank you.</p>
            <button onClick={() => setShowFeedbackPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
